import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import TableMemberships from "./TableMembership/TableMemberships";
import Loading from "../../components/Loading/Loading";
import { getAllMembershipsAPI } from "../../services/memberships/membershipService";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import AddIcon from "@mui/icons-material/Add";
import FormMembershipModal from "./ModalMembership";
import { useDispatch, useSelector } from "react-redux";
import { setListMemberships } from "../../redux/slice/membershipsSlice";

const Memberships = () => {
  const { listMemberships } = useSelector((state) => state.membershipsReducer);
  const [loading, setLoading] = useState(true);
  const [showModalMembership, setShowModalMembership] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAllMemberships = async () => {
      try {
        const listMemberships = await getAllMembershipsAPI();

        dispatch(setListMemberships({ listMemberships }));
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        dispatch(setListMemberships({ listMemberships: [] }));
        setLoading(false);
        toast.error(
          `Ocurrio un error mientras se procesaba la solicitud. \n ${message}`
        );
      }
    };
    getAllMemberships();
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <FormMembershipModal
        open={showModalMembership}
        setOpen={setShowModalMembership}
        setLoading={setLoading}
      />
      <Box sx={{ display: "flex", gap: 5 }}>
        <Typography variant="h4">Membresías</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<AddIcon />}
          onClick={() => setShowModalMembership(true)}
        >
          Agregar
        </Button>
      </Box>
      <TableMemberships setLoading={setLoading} rows={listMemberships ?? []} />
      <Loading loading={loading} />
    </Box>
  );
};

export default Memberships;
